import { Navigate, useLocation, useParams } from 'react-router-dom';

interface MemberPrefixRedirectProps {
  to: string;
}

export const MemberPrefixRedirect = ({ to }: MemberPrefixRedirectProps) => {
  const { '*': subPath } = useParams();
  const { search, hash } = useLocation();
  const pathname = subPath ? `${to}/${subPath}` : to;

  return <Navigate to={{ pathname, search, hash }} replace />;
};
